import React from "react";
import { cn } from "../../lib/utils";

const variants = {
  primary: "border-primary bg-primary text-primary-foreground hover:border-primary-hover hover:bg-primary-hover",
  secondary: "border-secondary bg-secondary text-secondary-foreground hover:bg-muted",
  outline: "border-border bg-surface text-foreground hover:border-primary/40 hover:bg-primary-subtle hover:text-primary-hover",
  ghost: "border-transparent bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground",
  danger: "border-danger bg-danger text-white hover:bg-danger/90",
  success: "border-success bg-success text-white hover:bg-success/90",
};
const sizes = { sm: "h-9 px-3 text-xs", md: "h-10 px-4 text-sm", lg: "h-12 px-5 text-sm", icon: "h-10 w-10 p-0" };

const Button = React.forwardRef(({ className, variant = "primary", size = "md", type = "button", children, ...props }, ref) => (
  <button ref={ref} type={type} className={cn("inline-flex shrink-0 items-center justify-center gap-2 rounded-md border font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50", variants[variant] || variants.primary, sizes[size] || sizes.md, className)} {...props}>{children}</button>
));
Button.displayName = "Button";
const IconButton = React.forwardRef(({ label, children, ...props }, ref) => <Button ref={ref} size="icon" aria-label={label} title={label} {...props}>{children}</Button>);
IconButton.displayName = "IconButton";
export { Button, IconButton };
